// @flow
import React from 'react';

import { BaseAIGeneratorDrawer } from '../BaseAIGeneratorDrawer';

import { usePresentationMakerGeneratorFormWithLogic } from './hooks/usePresentationMakerGeneratorFormWithLogic';

type PresentationMakerGeneratorDrawerProps = {
  leftContent?: React.ReactNode,
  submitButtonName?: string,
  title?: string,
  defaultPresentationContent?: Object,
  footerExtraButtons?: Array,
  open?: boolean,
  isAutoRetrievalEnabled?: boolean,
  optionsExtendedParams: Object,
  isFormEnabled?: boolean,
  onClickGenerate: () => void,
  onClickRateButton?: (data: Object) => void,
  onClose: () => void,
  renderErrorState?: (data: Object) => React.ReactNode,
  renderInitialState?: (data: Object) => React.ReactNode,
  presentationTypeId?: string
};

export const PresentationMakerGeneratorDrawer = ({
  defaultPresentationContent = null,
  footerExtraButtons = [],
  isAutoRetrievalEnabled = false,
  isFormEnabled = true,
  leftContent,
  onClickGenerate,
  onClickRateButton,
  onClose,
  open = true,
  optionsExtendedParams = {},
  presentationTypeId = null,
  renderErrorState,
  renderInitialState,
  rightContentFooter,
  submitButtonName,
  title,
  ...otherProps
}: PresentationMakerGeneratorDrawerProps) => {
  return (
    <BaseAIGeneratorDrawer
      autoGenerationConfig={{
        enabled: isAutoRetrievalEnabled,
        defaultContent: defaultPresentationContent,
        condition: presentationTypeId,
        presentationTypeId,
        defaultPresentationContent,
        footerExtraButtons,
        onClickGenerate,
        onClickRateButton
      }}
      footerExtraButtons={footerExtraButtons}
      formHook={usePresentationMakerGeneratorFormWithLogic}
      isFormEnabled={isFormEnabled}
      leftContent={leftContent}
      onClickGenerate={onClickGenerate}
      onClickRateButton={onClickRateButton}
      onClose={onClose}
      open={open}
      optionsExtendedParams={optionsExtendedParams}
      renderErrorState={renderErrorState}
      renderInitialState={renderInitialState}
      rightContentFooter={rightContentFooter}
      submitButtonName={submitButtonName}
      title={title}
      {...otherProps}
    />
  );
};
